import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-valeur',
  templateUrl: './valeur.component.html',
  styleUrls: ['./valeur.component.scss']
})
export class ValeurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
